    
(function(){
  document.addEventListener('DOMContentLoaded', function() {
    
      console.log(123123);
    let dataPallets = JSON.parse(window.pallets_data);
    
    let inputs = document.querySelectorAll('input[type="radio"]+label');
    let quantityField = document.querySelector('[name="quantity_setter"]');
    let setQuantityBtn = document.querySelector('.quantity_setter #setQuantity');
    let currentVariant =  ! inputs ? inputs[0] : false;
    let popupApprove = document.querySelector('.popup_approve');
    let getPerfectVariants = document.querySelector('.get_perfect_variants');
    let clearChoise = document.querySelector('.clear_choise');
    let closePopup = document.querySelector('.popup_propose .close_popup');
    let closePopupApprove = document.querySelector('.popup_approve .close_popup');
    let overlayPopup = document.querySelector('.popup_propose .overlay_popup');
    let variantSelects = document.querySelectorAll('fieldset');   

    async function reloadGallery(urlProduct, variantId) {
      try {
        const response = await fetch(`/products/${urlProduct}?view=metafields`);
        
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newGallery = html.querySelector(`[data-variant-id="${variantId}"]`);
        const dataIdVariant = html.querySelector(`[data-id-variant="${variantId}"]`);
        const cardProduct = document.querySelectorAll(`[data-handle="${urlProduct}"]`);
        const containerForChange = cardProduct[0]?.querySelector('.slider--card.swiper');
        
        if (containerForChange && newGallery) {
          containerForChange.innerHTML = newGallery.innerHTML;
          containerForChange.classList.remove('swiper-initialized');
          window?.modalSwiperCardInitFreedom();
        }

       
        // window?.modalSwiperInitFreedom();
        let idModalContainer = containerForChange.querySelectorAll('[data-modal]');
        if ( idModalContainer ) {
          let modalID = idModalContainer[0].dataset.modal;
          let modalPopup = document.querySelector(`${modalID} .swiper.product-media-modal__content`);
          if ( modalPopup ) {
            dataIdVariant.classList = 'swiper product-media-modal__content';
            modalPopup.parentNode.replaceChild(dataIdVariant, modalPopup);
            window?.modalSwiperInitFreedom();
          }
        }
        
        return newGallery;
      } catch (error) {
        console.error('Some error on load gallery:', error);
        return null;
      }
    }


    variantSelects.forEach(elem => {
      let items = elem.querySelectorAll('label');
      let counter = 0;
      if ( items.length > 8 ) {
        items.forEach(color => {
          if (counter > 8 ) {
            color.classList.add('hidden');
          } 
          counter++;
        });
        var toggler = document.createElement('span');
        toggler.classList.add('toggler');
        toggler.innerHTML = `<span class="with_value">+${items.length - 8}</span><span class="minus">-</span>`;
        toggler.classList.add('closed');
        toggler.addEventListener('click', function(e) {
          e.preventDefault();
          let allItems = this.closest('fieldset').querySelectorAll('label');
          let checker;
          if (this.classList.contains('closed')) {
            checker = true;
            toggler.classList.remove('closed');
          } else {
            checker = false;
            toggler.classList.add('closed');
          }
          let i = 0;
          allItems.forEach(element => {
            if( checker ) {
              element.classList.remove('hidden');
            } else {
              if (i > 8 ) {
                element.classList.add('hidden');
              } 
            }
            i++;
          });
          
        });
        elem.appendChild(toggler);
        
      }
      
    });

    

    closePopup?.addEventListener('click', function(e) {
      e.preventDefault();
      this.closest('.popup_propose')?.classList.remove('active');
    });

    closePopupApprove?.addEventListener('click', function(e) {
      e.preventDefault();
      this.closest('.popup_approve')?.classList.remove('active');
      let imagePlace = this.closest('.popup_approve').querySelector('.image_place');
      if ( imagePlace ) {
        imagePlace.innerHTML = '<img class="preloader" src="https://cdn.shopify.com/s/files/1/0901/8851/3554/files/loading-25.gif?v=1753098092" width="25" height="25"/>';
      }
    });

    overlayPopup?.addEventListener('click', function(e) {
      e.preventDefault();
      this.closest('.popup_propose')?.classList.remove('active');
    });
    
    inputs?.forEach(elem => {
      elem.addEventListener('click', async function(e) {
        e.preventDefault();
        currentVariant = elem;
        
        popupApprove.classList.add('active');    
        
        
        let fullInfoHTML = elem.closest('.card-wrapper').querySelector('[data-product-full-info]');
        let variantsObj = JSON.parse(fullInfoHTML.innerHTML);
        
        let filteredItems = variantsObj.filter(item => item.title === elem.dataset.name);
        
        let currentPopupTitle = elem.closest('.freedom_system').querySelector('.popup_approve h4');
        // debugger;
        currentPopupTitle.innerHTML = filteredItems[0].name;
        
        let urlProduct = elem.closest('.grid__item').dataset.handle;
        let newGallery = await reloadGallery(urlProduct, filteredItems[0].id);
        console.log('newGallery1', newGallery);
        if ( ! filteredItems[0].featured_image ) return false;
          let currentPopup = elem.closest('.freedom_system').querySelector('.image_place');
        
          console.log('newGallery', newGallery);
          currentPopup.innerHTML = newGallery.innerHTML;
        
          currentPopup.classList.add('swiper');
          new Swiper(currentPopup, {
            navigation: {
              nextEl: currentPopup.querySelector('.swiper-button-next'),
              prevEl: currentPopup.querySelector('.swiper-button-prev'),
            },
            zoom: {
              maxRatio: 5,    
              minRatio: 1   
            },
            
          });

        let cardMediaImg = elem.closest('.card-wrapper').querySelector('.card__media img');
        cardMediaImg.setAttribute('src', filteredItems[0].featured_image.src);
        cardMediaImg.setAttribute('srcset', '');
      });
    });

        
   setQuantityBtn?.addEventListener('click', function(e) {
      e.preventDefault();
      currentVariant.setAttribute('data-quantity', quantityField.value);
      currentVariant.classList.toggle('toggled');
      popupApprove.classList.remove('active');
      quantityField.value = 1;
      getPerfectVariants?.classList.add('active');
      clearChoise?.classList.add('active');
    });

    getPerfectVariants?.addEventListener('click', function(e) {
      e.preventDefault();
      checkStatusToggled();
    });

    clearChoise?.addEventListener('click', function(e) {
      e.preventDefault();
      let labels = document.querySelectorAll('label[data-quantity]');
      let productsAdviced = document.querySelector('.popup_propose #product-grid');
      labels.forEach(elem => {
        elem.removeAttribute('data-quantity');
        elem.classList.remove('toggled');
      });
      getPerfectVariants?.classList.remove('active');
      clearChoise?.classList.remove('active');
      productsAdviced.innerHTML = '';
    });
      
  
     function checkStatusToggled() {
      let circle = document.querySelectorAll('[data-form="Circle"] input[type="radio"]+label.toggled');
      let square = document.querySelectorAll('[data-form="Square"] input[type="radio"]+label.toggled');
      let rectangle = document.querySelectorAll('[data-form="Rectangle"] input[type="radio"]+label.toggled');
      let listPallets = [];
          
       
       let result = {
         circle: countValues(circle), 
         square: countValues(square),
         rectangle: countValues(rectangle)
       }
       let palletsValues = countPallets(result, listPallets);
        console.log('palletsValues', palletsValues);

       loadRelatedProducts(palletsValues); 
      }

    function countPallets(result, listPallets) {
       const sortedResult = sortingResults(result);

       let pallets = dataPallets;
       for ( item in sortedResult ) { //recursion for remove from pallets array all not fit items
         pallets = pallets.filter(v => { 
           return parseInt(v[item], 10) === parseInt(sortedResult[item], 10);
         });
       }
       
       
       console.log('dataPallets', dataPallets);
        console.log('pallets', pallets);
      
         let figurasPallets = countingPalletsVaries( sortedResult, pallets, listPallets );
      
         return listPallets;
         console.log('listPallets', listPallets);
      
    }

    function countingPalletsVaries(sortedResult, pallets, listPallets ) { // count pallets, created for recursion
      let figurasPallets = {};
       let overVariants = {};
       if ( pallets.length === 0 ) {
         console.log('pallets = 0');
         for ( item in sortedResult ) {
           let sortedResultItem = parseInt(sortedResult[item], 10);
           if ( sortedResultItem != 0 ) { // if count of current figura not = 0, then do some action
             let figures = dataPallets.filter(v => parseInt(v[item], 10) === sortedResultItem);// get from full object items that include needed count of cuurent figura
             if ( figures.length === 0 ) {
               let figures = dataPallets.filter( (v) => {
                 let isOtherValuesHaveEnoght = false;
                 let vItem = parseInt(v[item], 10);
                 let answer = vItem != 0 && ( sortedResultItem / vItem !== sortedResultItem || vItem === 1 )  && sortedResultItem >= vItem
                              ? true 
                              : false; 
                 console.log(answer);
                 if ( ! answer ) return false; //close from this iteration, no have any sence be here
                 for ( itemInside in sortedResult ) { //checking if other values not more that
                   if ( itemInside === item ) continue;
                   isOtherValuesHaveEnoght = parseInt(v[itemInside], 10) <= parseInt(sortedResult[itemInside], 10);
                   if ( ! isOtherValuesHaveEnoght ) break;
                 }
                 return isOtherValuesHaveEnoght ? true : false;
               });
               console.log('finally', figures);
               figurasPallets[item] = {
                 pallets: '',
                 id: '',
                 overitems: 0,
                 original: {}
               }
               for( curentItem in sortedResult ) {
                 let sortedResultCurrentItem = parseInt(sortedResult[curentItem], 10);
                 let figuraPallets = {};
                 figuraPallets[curentItem] = {
                   pallets: 100000,
                   id: '',
                   overitems: 0,
                   original: {}
                 }
                 // debugger;
                 for ( figura in figures ) { //find biggest value
                   let currentFiguraItemCount = parseInt(figures[figura][curentItem], 10);
                   if ( sortedResultCurrentItem / currentFiguraItemCount < figuraPallets[curentItem].pallets ) {
                     figuraPallets[curentItem].overitems = sortedResultCurrentItem - Math.floor( sortedResultCurrentItem / currentFiguraItemCount );
                     figuraPallets[curentItem].id = figures[figura].id;
                     figuraPallets[curentItem].pallets = Math.floor(sortedResultCurrentItem / currentFiguraItemCount);
                     figuraPallets[curentItem].original = figures[figura];
                   } else {
                     figuraPallets[curentItem].overitems = figuraPallets[curentItem].overitems;
                     figuraPallets[curentItem].id = figuraPallets[curentItem].id;
                     figuraPallets[curentItem].pallets = figuraPallets[curentItem].pallets;
                     figuraPallets[curentItem].original = figuraPallets[curentItem].original;
                   }    
                   
                 }
                 if (figuraPallets[curentItem].pallets < figurasPallets[item].pallets || figurasPallets[item].pallets == '' ) {
                   figurasPallets[item] = JSON.parse(JSON.stringify(figuraPallets[curentItem]));
                 }
                 console.log(figurasPallets);
               }
                // debugger;
               
              let newSortedResult = sortedResult;
               let checker = 0;
               for ( elem in newSortedResult ) { //run by original saved object for minus from FIRST MAIN object values if need 
                 
                 if (figurasPallets[elem] && figurasPallets[elem].original && 
                     figurasPallets[elem].original[elem] !== 0 && 
                     newSortedResult[elem] >= figurasPallets[elem].original[elem] *  figurasPallets[elem].pallets ) {
                       console.log('figurasPallets[item].original', figurasPallets[elem].original);
                       newSortedResult[elem] = newSortedResult[elem] - parseInt(figurasPallets[elem].original[elem], 10) *  figurasPallets[elem].pallets;
                       checker++;
                 } else if ( parseInt(figurasPallets[item].original[elem]) != 0 && elem != 'id' ) { // check if pallet have another possible fit figures, and also remove from total object
                   console.log(123);
                    newSortedResult[elem] = newSortedResult[elem] - parseInt(figurasPallets[item].original[elem], 10) *  figurasPallets[item].pallets;
                 }
               }
               
               let resultTemp = {};
               for ( item in figurasPallets ) {
                 listPallets[figurasPallets[item].id] = listPallets[figurasPallets[item].id] ? listPallets[figurasPallets[item].id] + figurasPallets[item].pallets : figurasPallets[item].pallets;
                 console.log('item', figurasPallets[item]);
                 if ( figurasPallets[item].overitems === 0 ) continue; 
                 resultTemp[item] = figurasPallets[item].overitems;
               }
               
               if ( ! isEmptyObject(resultTemp) ) { // if we not spent all items by pallets, then using recursion for run function again
                 countingPalletsVaries(newSortedResult, pallets, listPallets); 
               } 

              
               console.log('thisFigurasPallets', figurasPallets);
             } else {
               let resultTemp = {};
               let figura = [];
               for ( f in sortedResult ) {
                 console.log(f);
                 console.log(item);
                 if ( f != item ) { //making filter for find pallet where current item will exactly, and rest values in perfect will 0.
                   figura = figures.filter(v => parseInt(v[f], 10) === 0 ); // checking if we have pallet where could fit at least one figuras full count ( for example we have pallet for 3 square and circle and we have 3 square and not have 3 circle)  
                 } else {
                   figura = figures.filter(v => parseInt(v[item], 10) === parseInt(sortedResult[item], 10)); // checking if we have pallet where could fit at least one figuras full count ( for example we have pallet for 3 square and circle and we have 3 square and not have 3 circle)  
                 }
                 
               }
               if ( figura[0] ) {
                 listPallets[figura[0].id] = listPallets[figura[0].id] ? parseInt(listPallets[figura[0].id], 10) + 1 : 1;
               }
               
             }
           }
         }
          return figurasPallets;
       } else { //if we have "perfect" pallete we add it to pallets object
         // listPallets[pallets[0].palette] = listPallets[pallets[0].palette] ? listPallets[pallets[0].palette] + 1 : 1;
         // listPallets[pallets[0].id] = listPallets[pallets[0].id] ? listPallets[pallets[0].id] + 1 : 1;
          pallets.forEach(elem => {
           listPallets[elem.id] = listPallets[elem.id] ? listPallets[elem.id] + 1 : 1;
         });
      }
    }

    function isEmptyObject(obj){
      return JSON.stringify(obj) === '{}'
    }

    function sortingResults(result) {
      return Object.entries(result)
            .sort((a, b) => b[1] - a[1])
            .reduce((acc, [key, value]) => {
              acc[key] = value;
              return acc;
            }, {});
    }

    function countValues(items) {
      let sum = 0;
      items.forEach(elem => {
        sum += parseInt(elem.getAttribute('data-quantity'), 10);
      });
      return sum;
    }

      function loadRelatedProducts(palletItems) {
        if ( ! palletItems ) return false;
        
        console.log('jsfile'); 
        
  
        // Stop if no data
        let container = document.querySelector('[data-section-type="proposed_pallets"] > ul');
        if ( ! container ) return false;
        let popupPropose = document.querySelector('.popup_propose');
        if ( ! popupPropose ) return false;
  
        let url = '/search?view=pallete&type=product&q=';
  
        let products = '';
        for ( item in palletItems) {
          if ( ! parseInt(item,10) ) continue;
          products += 'id:' + parseInt(item,10) + ' OR ';
        }
  
        url = url + encodeURIComponent(products);
  
        fetch(url).then(function(response) {
          return response.text();
        }).then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var count = doc.querySelectorAll('.product-grid').length;
          
          if (count > 0) {
            var results = doc.querySelector('.product-grid');
            container.innerHTML = results.innerHTML;
            for ( item in palletItems) {
              if ( ! parseInt(item,10) ) continue;
              let qtyInput = container.querySelectorAll(`.product-grid [data-id-product="${item}"] .quantity__input`);
              if ( qtyInput[0] ) {
                qtyInput[0].value = palletItems[item];
              }
            }
            container.classList.remove('hide');
            popupPropose.classList.add('active');
            
          } else {
            this.outputContainer.classList.add('hide');
            popupPropose.classList.remove('active');
          }
  
      });
    }


    window.modalSwiperCardInitFreedom = function modalSwiperInit() {
      let galleriesModal = document.querySelectorAll('.slider--card.swiper');
       if ( galleriesModal && galleriesModal.length > 0 ) {
       window.galleriesSwiperCard = [];
       let i = 0;
       galleriesModal.forEach( elem => {
         elem.dataset.indexSlider = i;
          window.galleriesSwiperCard[i] = new Swiper(elem, {
            // spaceBetween: 0,
            slidesPerView: 1,
            zoom: {
              containerClass: 'swiper-zoom-container',
              panOnMouseMove: true,
              maxRatio: 2,
              minRation: 1
            },
            loop: false,
            navigation: {
              nextEl: elem.querySelector('.swiper-button-next'),
              prevEl: elem.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
              750: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              990: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
            },
          });
         i++;
       });
        document.addEventListener('click', function(e) {
          if ( e.target.matches('.zoom_icon') || e.target.closest('.zoom_icon')) {
            e.preventDefault();
            let indexSlider = e.target.closest('product-modal').querySelector('[data-index-slider]');
            const currentSlide = window.galleriesSwiperCard[indexSlider.dataset.indexSlider].slides[window.galleriesSwiperCard[indexSlider.dataset.indexSlider].activeIndex];
        
            if (currentSlide.classList.contains('zoomed')) {
                currentSlide.classList.remove('zoomed');
                 window.galleriesSwiperCard[indexSlider.dataset.indexSlider].zoom.out(1);
            } else {
                currentSlide.classList.add('zoomed');
                 window.galleriesSwiperCard[indexSlider.dataset.indexSlider].zoom.in(2);
            }
          } else if ( e.target.matches('.product-media-modal__toggle') || e.target.closest('.product-media-modal__toggle') ) {
            document.body.classList.remove('overflow-hidden');
            document.body.dispatchEvent(new CustomEvent('modalClosed'));
            let productModal = document.querySelector('product-modal');
            productModal.removeAttribute('open');
          }
        });
      
    }
  }
  window?.modalSwiperCardInitFreedom();

    
    window.modalSwiperInitFreedom = function modalSwiperInit() {
      let galleriesModal = document.querySelectorAll('.product-media-modal__content.swiper:not(.swiper-initialized)');
     if ( galleriesModal && galleriesModal.length > 0 ) {
       window.galleriesSwiper = [];
       let i = 0;
       
       galleriesModal.forEach( elem => {
         elem.dataset.sliderIndex = i;
         elem.dataset.indexSlider = i;
          window.galleriesSwiper[i] = new Swiper(elem, {
            // spaceBetween: 0,
            slidesPerView: 1,
            // zoom: {
            //   containerClass: 'swiper-zoom-container',
            //   panOnMouseMove: true,
            //   maxRatio: 2,
            //   minRation: 1
            // },
            loop: false,
            navigation: {
              nextEl: elem.querySelector('.swiper-button-next-popup'),
              prevEl: elem.querySelector('.swiper-button-prev-popup'),
            },
            breakpoints: {
              750: {
                slidesPerView: 1,
              },
              990: {
                slidesPerView: 1,
              },
            },
          });
         i++;
       });
        document.addEventListener('click', function(e) {
          if ( e.target.matches('.zoom_icon') || e.target.closest('.zoom_icon')) {
            e.preventDefault();
            let indexSlider = e.target.closest('product-modal').querySelector('[data-index-slider]');
            const currentSlide = window.galleriesSwiper[indexSlider.dataset.indexSlider].slides[window.galleriesSwiper[indexSlider.dataset.indexSlider].activeIndex];
        
            if (currentSlide.classList.contains('zoomed')) {
                currentSlide.classList.remove('zoomed');
                 window.galleriesSwiper[indexSlider.dataset.indexSlider].zoom.out(1);
            } else {
                currentSlide.classList.add('zoomed');
                 window.galleriesSwiper[indexSlider.dataset.indexSlider].zoom.in(2);
            }
          } else if ( e.target.matches('.product-media-modal__toggle') || e.target.closest('.product-media-modal__toggle') ) {
            document.body.classList.remove('overflow-hidden');
            document.body.dispatchEvent(new CustomEvent('modalClosed'));
            let productModal = document.querySelector('product-modal');
            productModal.removeAttribute('open');
          }
        });
      
    }
  }
  window?.modalSwiperInitFreedom();
    
  }, false);
})();